"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderSelect = void 0;
const react_1 = __importDefault(require("react"));
const gender_1 = require("../../../../utils/gender");
const legacy_1 = require("../Select/legacy");
class GenderSelect extends react_1.default.PureComponent {
    render() {
        return react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { ...this.props });
    }
}
exports.GenderSelect = GenderSelect;
GenderSelect.defaultProps = {
    items: [
        '',
        {
            name: (0, gender_1.translateGender)('male'),
            value: 'male',
        },
        {
            name: (0, gender_1.translateGender)('female'),
            value: 'female',
        },
    ],
    label: null,
    value: undefined,
    placeholder: null,
};
//# sourceMappingURL=index.js.map